import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getAttributeNames } from 'gqlQueries/filterQueries';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useFetchAttributeNamesOnly() {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    //To fetch dim
    const [fetchAttributeNamesOnly, { data: attributeName, loading: attributeNameLoading, error: attributeNameError }] =
        useLazyQuery(getAttributeNames, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    useEffect(() => {
        setLoading(attributeNameLoading);
    }, [attributeNameLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            setCount(payload.getAttributeNames.meta.count);
            if (commonConfig.offset == variablesRef.current.offset && !variablesRef.current.searchKeyword.length) {
                setData([...payload.getAttributeNames.data]);
            } else if (
                commonConfig.offset != variablesRef.current.offset &&
                !variablesRef.current.searchKeyword.length
            ) {
                setData((oldData: any) => [...oldData, ...payload.getAttributeNames.data]);
            } else if (variablesRef.current.searchKeyword.length) {
                setData([...payload.getAttributeNames.data]);
            }
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        count,
        fetchAttributeNamesOnly: (variables: any) => {
            variablesRef.current = variables.variables;
            if (variables.variables.offset === commonConfig.offset) {
                setData(null);
                setCount(0);
            }
            fetchAttributeNamesOnly(variables);
        },
    };
}

export default useFetchAttributeNamesOnly;
